<template>
    <van-tabbar v-model="activeName" active-color="#111111" inactive-color="#999999" @change="onChange">
        <van-tabbar-item v-for="(item,index) in dataList" :key="index" :name="item.name">
            <div style="margin-top: 0.06rem;font-size: 13px;">{{ item.label }}</div>
            <template #icon="props">
                <img :src="props.active ? item.active : item.inactive" />
            </template>
        </van-tabbar-item>
    </van-tabbar>
</template>

<script>
export default {
    name:'Tabbar',
    props:{
        active:{
            required: true,
            type: String,
        }
    },
  data() {
    return {
        activeName:'',
        dataList:[
            {name:'periodization',label:'分期',active:require('@/assets/tabbar/icon-fq-active.png'),inactive:require('@/assets/tabbar/icon-fq.png')},
            {name:'bill',label:'账单',active:require('@/assets/tabbar/icon-zd-active.png'),inactive:require('@/assets/tabbar/icon-zd.png')},
        ],
    };
  },
  created(){
    this.activeName = this.active
  },
  methods:{
    onChange(){
        console.log(this.activeName,'color-2')
        this.$router.push({
            name:this.activeName
        })
    }
  }
};
</script>